import { call } from 'redux-saga/effects';
import { AccountResource } from '../../core/resources/account.resource';
import {
  autoRenewalSerializer,
  subscriptionSerializer,
} from '../../models/subscription/subscription.serializer';

export function* getSubscription() {
  const response = yield call(AccountResource.getMySubscription);

  return subscriptionSerializer(response);
}

export function* getAutoRenewalStatus() {
  const response = yield call(AccountResource.getMyAutoRenewalStatus);

  return autoRenewalSerializer(response);
}

export function* cancelAutoRenewal(reason: string) {
  return yield call(AccountResource.cancelAutoRenewal, reason);
}

export function* postReactivateAutoRenewal() {
  return yield call(AccountResource.postReactivateAutoRenewal);
}
